import { useEffect, useRef } from 'react';
import { subscribeToHubEvent } from '../services/realtimeHub';

/**
 * Suscribe un componente a un evento de la conexión SignalR compartida.
 * El handler va en un ref: los re-renders no re-suscriben ni reinician la conexión.
 *
 * Recuerda que el tiempo real es solo optimización — el componente debe conservar
 * su polling (lento) como fallback por si el websocket se cae.
 */
export function useHubEvent(
  eventName: string,
  handler: (payload?: any) => void,
  enabled = true
) {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (!enabled) return;
    return subscribeToHubEvent(eventName, (payload) => handlerRef.current(payload));
  }, [eventName, enabled]);
}
